import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { FormInputProps, Option } from "./types";
import useOptions from "./hooks";

type IconButtonsProps = FormInputProps & {
    onClick?: any;
}

const IconButtons = (props: IconButtonsProps) => {
    const {
        name,
        selectOptions,
        cssName,
        fieldOptions
    } = props.config;

    const { register, watch, formState: { errors } } = useFormContext();

    const fieldName = props.config.name;

    const watchValue = props.watch ? watch([name]) : undefined;

    const fieldRegistration = register(name, fieldOptions);

    useEffect(() => {
        if (!watchValue) {
            return;
        }

        const subscription = watch((value, { name, type }) => {
            if (name !== fieldName) {
                return;
            }

            props.watch(value[fieldName]);
        });

        return () => subscription.unsubscribe()
    }, watchValue);

    const options = selectOptions as Option[];

    const [getValue, getLabel] = useOptions(options);

    const className = !!cssName ? { "className": cssName } : {}

    //Note: Need to use onClick as clicking on a value that is already selected
    //does not trigger watch or onChange
    const onClick = (e: any) => {
        if (!props.onClick) {
            return;
        }

        let parent = e.target;

        while (parent.tagName.toLowerCase() !== "li") {
            parent = parent?.parentElement;

            if (!parent) {
                break;
            }
        }

        const checkedInput = parent?.querySelector("input:checked");

        if (!checkedInput) {
            return;
        }

        props.onClick();
    }

    return (<div {...className}>
        <ul className="form-icon-options">
            {options.map((o, index) => (
                <li key={`${name}-${index}`}>
                    <label htmlFor={`${name}-${index}`} onClick={(e) => setTimeout(() => onClick(e), 100)}>
                        <i className={getLabel(o).toString()}></i>
                        {getValue(o)}
                    </label>
                    <input
                        id={`${name}-${index}`}
                        type="radio"
                        value={getValue(o)}
                        {...fieldRegistration}
                    // onChange={(e) => {
                    //     fieldRegistration.onChange(e);

                    //     if (props?.onChange) {
                    //         props.onChange(e);
                    //     }
                    // }} 
                    />
                </li>
            ))}
        </ul>

        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
}

export default IconButtons;